<template>
    <div>
        <b-btn
            v-if="remote && inProgress"
            v-bind="$attrs"
            v-on="$listeners"
            :disabled="true"
        >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i
                class="fas fa-clock"
            ></i
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </b-btn>
        <b-btn v-else v-bind="$attrs" v-on="$listeners">
            <slot></slot>
        </b-btn>
    </div>
</template>
<script>
export default {
    props: {
        remote: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
